module.exports = __webpack_public_path__ + "img/mappin.ec9aaad5.svg";